import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject, OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';
import { switchMap, tap } from 'rxjs/operators';
import { BaseComponent } from 'src/app/_core/tools/base.component';
import { SharedAdvancedSettlementComponent } from 'src/app/_shared/components/settlements/shared-advanced-settlement/shared-advanced-settlement.component';
import { FactureDto } from 'src/graphql/generated-types';
import {
    SharedAdvancedSettlement,
    SharedAdvancedSettlementSetInformationsAction
} from 'src/app/_shared/stores/settlements/shared-advanced-settlement/shared-advanced-settlement.actions';
import { ResetSharedPaymentMethodsStateAction } from 'src/app/_shared/stores/settlements/shared-payment-methods/shared-payment-methods.action';
export interface SharedAdvancedSettlementDialogData extends SharedAdvancedSettlement {

    accepted?: boolean;

}

@Component({
    selector: 'app-shared-advanced-settlement-dialog',
    templateUrl: './shared-advanced-settlement-dialog.component.html',
    styleUrls: ['./shared-advanced-settlement-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedAdvancedSettlementDialogComponent extends BaseComponent implements OnInit {

    isAdvancedSettlementDisplayed = false;

    @ViewChild(SharedAdvancedSettlementComponent) advancedPaymentComponent: SharedAdvancedSettlementComponent<FactureDto>;

    constructor(protected readonly cdr: ChangeDetectorRef,
                private readonly dialogRef: KalDialogRef<SharedAdvancedSettlementDialogComponent>,
                @Inject(KAL_DIALOG_DATA) public data: SharedAdvancedSettlementDialogData) {

        super(cdr);
    }

    get canPay(): boolean {
        return this.advancedPaymentComponent?.canPay || false;
    }

    get loading(): boolean {
        return this.advancedPaymentComponent?.loading;
    }

    set loading(loading: boolean) {
        this.advancedPaymentComponent.loading = loading;
        this.cdr.markForCheck();
    }

    save(): void {
        // dispatch create reglement
        this.watch$ = this.advancedPaymentComponent.save().pipe(
            switchMap(() => this.dispatch$(new ResetSharedPaymentMethodsStateAction())),
            tap(() => {
                this.data.accepted = true;
                this.dialogRef.close(this.data);
            })
        );
    }

    cancel(): void {
        this.watch$ = this.dispatch$(new ResetSharedPaymentMethodsStateAction()).pipe(
            tap(() => {
                this.dialogRef.close();
            })
        );
    }

    invoicePaidByCreditDeposit(): void {
        this.data.accepted = true;
        this.dialogRef.close(this.data);
    }

    ngOnInit(): void {
        const {accepted, ...advancedSettlement} = this.data;
        this.watch$ = this.dispatch$(new SharedAdvancedSettlementSetInformationsAction(advancedSettlement)).pipe(
            tap(() => {
                this.isAdvancedSettlementDisplayed = true;
                this.cdr.markForCheck();
            })
        );
    }

}
